import { Component, OnInit } from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';

@Component({
    standalone: false,
    selector: 'app-email-blast-recipient-dialog-def-editor',
  templateUrl: './email-blast-recipient-dialog-def-editor.component.html',
  styleUrls: ['./email-blast-recipient-dialog-def-editor.component.scss']
})
export class EmailBlastRecipientDialogDefEditorComponent extends DialogDefinitionEditorBase implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
